// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectedValues_wrapper__jpxs8","inner":"SelectedValues_inner__WI5Xw","value":"SelectedValues_value__lT65z","valueActive":"SelectedValues_valueActive__mBzVq"};